import { useState, useEffect } from 'react';

/**
 * Returns true if Multi-Branch Features (Request Stock, Branch Stock, Inter-Branch Transfer, Branch Sync) are enabled.
 * Defaults to false (disabled) if no setting has been saved.
 */
export const isMultiBranchEnabled = () => {
    try {
        const cached = localStorage.getItem('enable_multi_branch');
        return cached === 'true';
    } catch (e) {
        return false;
    }
};

/**
 * Hook providing reactive access to the Multi-Branch enabled state.
 * Listens for local updates and cross-tab storage changes.
 */
export const useMultiBranchSetting = () => {
    const [enableMultiBranch, setEnableMultiBranch] = useState(isMultiBranchEnabled());

    useEffect(() => {
        const handleStorageChange = () => {
            setEnableMultiBranch(isMultiBranchEnabled());
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('multi_branch_setting_changed', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('multi_branch_setting_changed', handleStorageChange);
        };
    }, []);

    const updateMultiBranchSetting = (enabled) => {
        const strVal = enabled ? 'true' : 'false';
        localStorage.setItem('enable_multi_branch', strVal);
        setEnableMultiBranch(enabled);
        window.dispatchEvent(new Event('multi_branch_setting_changed'));
        window.dispatchEvent(new Event('storage'));
    };

    return { enableMultiBranch, updateMultiBranchSetting };
};

export default useMultiBranchSetting;
